(() => {
  function setup() {
    document.querySelectorAll('.af-kit-dock').forEach(dock => {
      if (dock.dataset.ready) return;
      const original = document.getElementById(dock.dataset.nativeSubmit);
      const button = dock.querySelector('button');
      if (!original || !button) return;
      dock.dataset.ready = 'true';
      const sync = () => { button.disabled = original.disabled || original.getAttribute('aria-disabled') === 'true'; };
      sync();
      new MutationObserver(sync).observe(original, { attributes: true, attributeFilter: ['disabled', 'aria-disabled'] });
      // Reuse the original native product form, quantity rules and cart error handling.
      button.addEventListener('click', () => { if (!button.disabled) original.click(); });
    });
    const context = new URLSearchParams(location.search).get('product');
    const contact = document.querySelector('#send-a-message form');
    if (context && contact && !contact.dataset.contextSet) {
      const body = contact.querySelector('[name="contact[body]"]');
      if (body && !body.value) body.value = `Product: ${context.slice(0, 160)}\n\nMy question: `;
      contact.dataset.contextSet = 'true';
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', setup); else setup();
  document.addEventListener('shopify:section:load', setup);
})();
